
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)

      return styles
    },
    bodyStyles() {
      const styles = {}

      styles.rowGap = this.getBreakpointValue(this.blok.bodyRowGap)
      styles.padding = this.getBreakpointValue(this.blok.bodyPadding)

      return styles
    },
    footerStyles() {
      const styles = {}

      styles.rowGap = this.getBreakpointValue(this.blok.footerRowGap)
      styles.padding = this.getBreakpointValue(this.blok.footerPadding)

      return styles
    },
  },
}
